import * as React from "react";
import { TransitionGroup } from "react-transition-group";
import FadeAndSlideTransition from "../../transitions/FadeAndSlideTransition";
import NotificationComponent from "../Notification/Notification";
import styles from "./styles.module.scss";
import Notification from "@blacknut/javascript-sdk/dist/model/Notification";
interface NotificationsProps {
  maxTime?: number;
  notifications: Notification[];
  renderNotification?: (n: Notification) => JSX.Element;
}
const Notifications = ({
  notifications,
  renderNotification,
  maxTime,
}: NotificationsProps) => {
  const [tick, setTick] = React.useState(new Date().getTime());

  const cssVar = window
    .getComputedStyle(document.documentElement)
    .getPropertyValue("--toaster-max-time");
  const _maxTime =
    maxTime ||
    (cssVar && parseInt(cssVar, 10)) ||
    (process.env.NODE_ENV === "test" ? 500 : 2000);
  React.useEffect(() => {
    const timeout = setTimeout(() => {
      setTick(new Date().getTime());
    }, _maxTime);
    return () => {
      clearTimeout(timeout);
    };
  }, [notifications, _maxTime]);
  return (
    <TransitionGroup className={styles.list} component="div">
      {notifications.map((n) => {
        return (
          <FadeAndSlideTransition
            direction="up_in"
            duration={350}
            key={`${n.localizedMessage || n.message}-${n.time}`}
            inProp={tick - n.time < _maxTime}
          >
            <>
              {renderNotification && renderNotification(n)}
              {!renderNotification && (
                <NotificationComponent notification={n} />
              )}
            </>
          </FadeAndSlideTransition>
        );
      })}
    </TransitionGroup>
  );
};
export { Notifications };
export default Notifications;
